module.exports = __webpack_public_path__ + "img/ruantingting.526d810c.jpg";